<template>
  <!-- <el-card> -->
  <div class="guests-list">
      <template v-if="lan=='ch'">
      <div :class="ExhibitionTypeEnum.HAS_ENDED == exhState ? 'guestsList-wrap1' : 'guestsList-wrap'" v-for="(item, index) in guestsListdata" :key="index">
        <div class="guestsList-top-right-gz" v-if="item.user_type == 2">
          <div class="guestsList-top-right-title">{{item.register_area==1?language.registerAreaCh:language.registerAreaEn}}嘉宾</div>
        </div>
        <div class="guestsList-top-right-cz" v-if="item.user_type == 1">
          <div class="guestsList-top-right-title">{{item.register_area==1?language.registerAreaCh:language.registerAreaEn}}展商</div>
        </div>
        <div class="guestsList-wrap-top">
          <span class="guestsList-wrap-top-name">{{item.true_name || item.true_name_en}}</span>
          <span class="guestsList-wrap-top-position">{{item.user_post || item.user_post_en}}</span>
        </div>
        <div class="guestsList-wrap-content">
          <p class="guestsList-wrap-content-companyName">{{item.company || item.company_en}}</p>
          <p class="guestsList-wrap-content-address">公司所在城市：{{item.location || item.location_en}}</p>
          <p class="guestsList-wrap-content-tel" v-if="token  && showGuestsType">联系方式：{{item.tel}}</p>
          <p class="guestsList-wrap-content-tel"  v-else>联系方式：报名可见</p>
          <p class="guestsList-wrap-content-Email"  v-if="token && showGuestsType">邮箱：{{item.email}}</p>
          <p class="guestsList-wrap-content-Email" v-else>邮箱：报名可见</p>
        </div>
        <div v-if="item.is_wiffa == 1" style="margin-top: 18px;margin-left: 20px;">
          <img class="guestsList-wrap-content-img" src="../../../assets/icon_wiffa_new.png" alt="">
        </div>
      </div>
      </template>
        <!-- <div class="guestsList-wrap-content-footer" v-if="item.broadcast_id != 0">
          <el-button type="warning" style="height: 40px;width: 100px !important;float: right;padding:1px 6px;"
          v-if="ExhibitionTypeEnum.ONGOING == exhState"
          @click="handleInfo(stateEnum.JOIN_DISCUSS,item)">
            {{language.negotiation}}
          </el-button>
          <el-button type="warning" style="height: 40px;float: right;width: 100px !important;background-color: #0f408a;border: none;margin-right: 20px;padding:1px 6px;"
          v-if="
          ExhibitionTypeEnum.HAS_ENDED != exhState
          &&
          ExhibitionTypeEnum.END_HAS_ENDED != exhState
          &&item.subscribe_type != 1
          "
          @click="handleMake(item)">
            {{language.ahead}}
          </el-button>
          <el-button type="warning"
          v-if="token && item.subscribe_type == 1"
          style="height: 40px;float: right;width: 100px !important;background-color: #0f408a;border: none;margin-right: 20px;padding:1px 6px;"
          @click="handleUnMake(item)">{{language.unfollow}}</el-button>
        </div> -->
      <template v-else>
        <div :class="ExhibitionTypeEnum.HAS_ENDED == exhState ? 'guestsList-wrap-en1' : token && showGuestsType ? 'guestsList-wrap-en' : 'guestsList-wrap-en2'" v-for="(item, index) in guestsListdata" :key="index">

        <div class="guestsList-top-right-gz" v-if="item.user_type == 2">
          <div class="guestsList-top-right-title">{{item.register_area==1?'DomesticGuest':'Guest'}}</div>
        </div>

        <div class="guestsList-top-right-cz" v-if="item.user_type == 1">
          <div class="guestsList-top-right-title">Exhibitor</div>
        </div>

        <div class="guestsList-wrap-top">
          <span class="guestsList-wrap-top-name">{{item.true_name_en || item.true_name}}</span>
          <span class="guestsList-wrap-top-position">{{item.user_post_en || item.user_post}}</span>
        </div>

        <div class="guestsList-wrap-content">
          <p class="guestsList-wrap-content-companyName">{{item.company_en || item.company}}</p>
          <p class="guestsList-wrap-content-address">Address：{{item.location_en || item.location}}</p>
          <p class="guestsList-wrap-content-tel-en" v-if="token && showGuestsType">Tel：{{item.tel}}</p>
          <p class="guestsList-wrap-content-tel-en" v-else>Tel：Registration visible</p>
          <p class="guestsList-wrap-content-Email" v-if="token && showGuestsType">Email：{{item.email}}</p>
          <p class="guestsList-wrap-content-Email" v-else>Email：Registration visible</p>
          
        </div>
        <div v-if="item.is_wiffa == 1"  style="margin-top: 18px;margin-left: 20px;">
          <img class="guestsList-wrap-content-img" src="../../../assets/icon_wiffa_new.png" alt="">
        </div>
      </div>

      </template>
      
      <!-- <div class="guestsList-wrap-content-footer" v-if="item1.broadcast_id != 0">
          <el-button type="warning" style="height: 40px;width: 100px !important;float: right;padding:1px 6px;"
          v-if="ExhibitionTypeEnum.ONGOING == exhState"
          @click="handleInfo(stateEnum.JOIN_DISCUSS,item1)">
            {{language.negotiation}}
          </el-button>
          <el-button type="warning" style="height: 40px;float: right;width: 100px !important;background-color: #0f408a;border: none;margin-right: 20px;padding:1px 6px;"
          v-if="
          ExhibitionTypeEnum.HAS_ENDED != exhState
          &&
          ExhibitionTypeEnum.END_HAS_ENDED != exhState
          &&item1.subscribe_type != 1
          "
          @click="handleMake(item1)">
            {{language.ahead}}
          </el-button>
          <el-button type="warning"
          v-if="token && item1.subscribe_type == 1"
          style="height: 40px;float: right;width: 100px !important;background-color: #0f408a;border: none;margin-right: 20px;padding:1px 6px;"
          @click="handleUnMake(item1)">{{language.unfollow}}</el-button>
        </div>-->
  </div>
  <!-- </el-card> -->
</template>

<script>
import {ExhibitionTypeEnum} from "../../../common/constant/exhibition";
import errorImage from "../../../assets/error_room.png"
import { mapGetters } from "vuex";
import Cookie from "../../../common/cookie";
import {stateEnum} from "./enum";
export default {
  computed: {
    ...mapGetters(["token"])
  },
  methods: {
      handleInfo(stateInfo,item) {
        this.$emit("getLiveInfo", {state: stateInfo, id: item.broadcast_id},item.broadcast_id)
      },
      //预约
      handleMake(item) {
        this.$emit("getLiveInfo", {state: this.stateEnum.SUBSCRIBE, id: item.broadcast_id})
      },
      //取消预约
      handleUnMake(item) {
        this.$emit("getLiveInfo", {state: this.stateEnum.CANCELSUB, id: item.broadcast_id})
      },
  },
  props: {
    guestsListdata: {
      type: Array,
      default: () => []
    },
    language: {
        type: Object,
        default: () => {}
    },
    showGuestsType:{
      type: Boolean
    },
    exhState: {}
  },
  data() {
    return {
      ExhibitionTypeEnum,
      stateEnum,
      errorImage,
      lan: Cookie.get("lang"),
    };
  }
};
</script>

<style scoped>
/* font-family: MicrosoftYaHeiLight; */
.el-card{
  border: 0px solid #EBEEF5;
  margin-top: 0px !important;
  padding: 0 0 20px 0;
}
.guests-list{
  /* margin-top: 0px !important;
  margin-bottom: 20px; */
  height: auto;
}
.el-card >>> .el-card__body{
  padding: 2px !important;
}
.guestsList-wrap{
  background: #ffffff;
  float:left;
  width: 32%;
  height:330px;
  -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  margin-top:2%;
  position: relative;
}

.guestsList-wrap1{
  background: #ffffff;
  float:left;
  width: 32%;
  height:330px;
  -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  margin-top:2%;
  position: relative;
}
.guestsList-wrap:nth-child(3n-1){
  margin: 2% 2% 0;
}
.guestsList-wrap1:nth-child(3n-1){
  margin: 2% 2% 0;
}

.guestsList-wrap-en{
  background: #ffffff;
  float:left;
  width: 32%;
  height:330px; 
  /* min-height: 330px;*/
  -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  margin-top:2%;
  position: relative;
}

.guestsList-wrap-en1{
  background: #ffffff;
  float:left;
  width: 32%;
  height:330px;
  -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  margin-top:2%;
  position: relative;
}
.guestsList-wrap-en2{
  background: #ffffff;
  float:left;
  width: 32%;
  height:300px;
  -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  margin-top:2%;
  position: relative;
}
.guestsList-wrap-en:nth-child(3n-1){
  margin: 2% 2% 0;
}
.guestsList-wrap-en1:nth-child(3n-1){
  margin: 2% 2% 0;
}
.guestsList-wrap-en2:nth-child(3n-1){
  margin: 2% 2% 0;
}
.guestsList-wrap-top{
  margin: 0 auto;
  width: 90%;
  /* border-bottom: 1px solid #d8d8d8; */
}
.guestsList-wrap-top-name{
  display: inline-block;
 font-size: 26px;
 min-height: 15px;
 margin: 50px 10px 10px 0px;
 word-break: break-word;
 color: #0b8afd;

}
.guestsList-wrap-top-position{
 font-size: 16px;
 margin: 20px 0px 10px 0px;
 color: #0b8afd;
}
.guestsList-wrap-content{
  margin: 20px auto 0;
  width: 90%;
  min-height: 150px;
  background: #f6f6f6;
}

.guestsList-wrap-content-companyName{
  min-height: 42px;
 color: #333;
 font-size: 16px;
 padding: 15px 20px;
}
.guestsList-wrap-content-address{
  color: #8e8e8e;
  font-size: 14px;
  /* padding-bottom: 4px; */
  padding: 0 20px 4px;
}
.guestsList-wrap-content-tel{
 color: #8e8e8e;
 font-size: 14px;
 /* padding-bottom: 4px; */
  padding: 0 20px 4px;
}
.guestsList-wrap-content-tel-en{
 color: #8e8e8e;
 font-size: 14px;
 /* padding-top: 15px;
 padding-bottom: 4px; */
padding: 0px 20px 4px;
}
.guestsList-wrap-content-Email{
 color: #8e8e8e;
 font-size: 14px;
 display: inline-block;
 padding: 0 20px;
 margin-bottom: 20px;
}
.guestsList-wrap-content-footer{
  position: absolute;
  bottom: 20px;
  right: 10px;
  display: inline-block;
}
.guestsList-top-right-gz{
  height: 40px;
  background: linear-gradient(to top left, #41d0fe, #055ee8);
  background-size: 100% 100%;
  border-top-left-radius: 40px;
  border-bottom-left-radius: 40px;
  padding: 0 5px 0 20px;
  position: absolute;
  top: 20px;
  right: 0px;
}
.guestsList-top-right-cz{
  height: 40px;
  background: linear-gradient(to top left, #f2a166, #f06626);
  background-size: 100% 100%;
  border-top-left-radius: 40px;
  border-bottom-left-radius: 40px;
  padding: 0 5px 0 20px;
  position: absolute;
  top: 20px;
  right: 0px;
}
.guestsList-top-right-title{
  text-align: center;
  line-height: 35px;
  font-size: 16px;
  color: #fff;
}

.guestsList-wrap-content-img{
  width: 74px;
  height: 20px;
}
</style>
